// extracted by mini-css-extract-plugin
export default {"tableBtn":"Users_tableBtn__73fXR","name":"Users_name__H-Mpx","email":"Users_email__r3T6y"};